import { useState } from "react";
import { BrainCircuit } from "lucide-react";
import { motion } from "motion/react";

export default function LoadingScreen() {
  const messages = [
    "Analysing your responses…",
    "Mapping your personality profile…",
    "Matching you to the best fields…",
    "Almost ready!",
  ];
  const [msgIdx] = useState(0);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="max-w-sm mx-auto text-center py-16"
    >
      <div className="w-20 h-20 rounded-full bg-gradient-to-br from-violet-600 to-purple-600 flex items-center justify-center mx-auto mb-6 shadow-xl shadow-violet-500/25">
        <BrainCircuit className="w-9 h-9 text-white animate-pulse" />
      </div>
      <p
        className="text-[18px] text-slate-800 mb-2"
        style={{ fontWeight: 700 }}
      >
        {messages[msgIdx]}
      </p>
      <p className="text-[13px] text-slate-400" style={{ fontWeight: 400 }}>
        Hang tight — your results are being prepared
      </p>
      <div className="flex justify-center gap-1.5 mt-8">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="w-2.5 h-2.5 rounded-full bg-violet-400 animate-bounce"
            style={{ animationDelay: `${i * 0.2}s` }}
          />
        ))}
      </div>
    </motion.div>
  );
}
